import styled, { css } from 'styled-components';
import { rem } from 'polished';
import mediaqueries from '../../../config/themes/variables/mediaqueries';
import DateFormat from '../DateFormat';
import ButtonPlus from '../ButtonPlus';
import Icon from '../Icon';

const StyledTitle = styled.h2`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('15px')};
  margin: 0 0 ${rem('10px')} 0;
  text-transform: uppercase;
  ${mediaqueries.greaterThan('tablet')`
    margin: 0 0 ${rem('16px')} 0;
    padding-left: 0;
  `};
`;

const StyledTitleEditable = styled.p`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('22px')};
  margin-bottom: 0;
  text-align: right;
  text-transform: uppercase;
`;

const StyledExperience = styled.ul`
  margin: 0;
  padding: 0;
`;

const StyledElement = styled.li`
  display: flex;
  padding: ${rem('22px')} 0 0 0;
  :after {
    background: ${props => props.theme.colors.primary};
    content: '';
    height: calc(100% + ${rem('12px')});
    left: ${rem('87px')};
    position: absolute;
    top: ${rem('27px')};
    width: ${rem('3px')};
    z-index: 2;
  }
  :before {
    border: ${rem('3px')} solid ${props => props.theme.colors.primary};
    border-radius: 50%;
    height: ${rem('15px')};
    left: ${rem('81px')};
    top: ${rem('27px')};
    width: ${rem('15px')};
    z-index: 1;
  }
  :last-child:after {
    content: none;
  }
  ${props =>
    props.actual &&
    props.editable &&
    css`
      background-color: ${props.theme.colors.grayLightest};
    `};
  ${mediaqueries.greaterThan('desktop')`
    padding: ${rem('22px')} ${rem('15px')} 0 0;
    :after {
      left: ${rem('123px')};
    }
    :before {
      left: ${rem('117px')};
    }
  `};
`;

const StyledCurrentJobWrapper = styled.div`
  position: relative;
`;

const StyledBox = styled.div`
  flex: 0 0 ${rem('98px')};
  margin-right: 0;
  ${mediaqueries.greaterThan('desktop')`
    margin-right: ${rem('51px')};
    text-align: right;
  `};
`;

const StyledBoxLine = styled.div`
  margin-top: ${rem('5px')};
  ${mediaqueries.greaterThan('mobile')`
    align-items: center;
    display: flex;
    margin-top: 0;
  `};
`;

const StyledMonth = styled(DateFormat)`
  color: ${props => props.theme.colors.grayDark};
  display: block;
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${props => props.theme.fontSize.small};
  letter-spacing: ${rem('-1px')};
  line-height: ${rem('11px')};
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('16px')};
  `};
`;

const StyledActuallity = styled.p`
  color: ${props => props.theme.colors.dark};
  display: block;
  font-family: ${props => props.theme.fonts.bold};
  letter-spacing: ${rem('-1px')};
  line-height: ${rem('24px')};
  margin-bottom: 0;
  text-transform: uppercase;
  padding-right: ${rem('10px')};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.large};
  `};
`;

const StyledYear = styled(DateFormat)`
  color: ${props => props.theme.colors.dark};
  display: block;
  font-family: ${props => props.theme.fonts.bold};
  letter-spacing: ${rem('-1px')};
  line-height: ${rem('24px')};
  margin-bottom: 0;
  text-transform: uppercase;
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.large};
  `};
`;

const StyledCompany = styled.h3`
  color: ${props => props.theme.colors.primary};
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  letter-spacing: ${rem('-0.8px')};
  line-height: ${rem('16px')};
  margin: 0 ${rem('10px')} 0 0;
`;

const StyledButtonPlus = styled(ButtonPlus)`
  width: ${rem('24px')};
  height: ${rem('24px')};
  margin: ${rem('15px')} 0 0 ${rem('16px')};
  ${mediaqueries.greaterThan('mobile')`
    margin: ${rem('20px')} 0 0 ${rem('36px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    margin: ${rem('10px')} 0 0 ${rem('36px')};
  `};
`;

const StyledPen = styled(Icon)`
  margin-left: ${rem('12px')};
  margin-bottom: ${rem('8px')};
  position: relative;
  top: ${rem('4px')};
  ${mediaqueries.greaterThan('desktop')`
    margin-left: ${rem('8px')};
    top: ${rem('6px')};
    width: ${rem('16px')};
  `};
`;

const StyledEditable = StyledPen.extend`
  position: absolute;
  right: ${rem('10px')};
  top: ${rem('25px')} !important;
  z-index: 1;
`;

const StyledTrash = StyledPen.extend`
  margin-left: ${rem('10px')};
  top: ${rem('2px')};
  ${mediaqueries.greaterThan('desktop')`
    top: ${rem('3px')};
  `};
`;

const StyledCrate = styled.div`
  margin-bottom: ${rem('35px')};
  padding-top: 0;
  padding-left: ${rem('15px')};
  ${mediaqueries.greaterThan('mobile')`
    padding-right: ${rem('44px')};
  `};
  ${mediaqueries.greaterThan('desktop')`
    padding-left: 0;
  `};
`;

const StyledJob = styled.h4`
  font-family: ${props => props.theme.fonts.medium};
  font-size: ${rem('16px')};
  letter-spacing: ${rem('-0.7px')};
  margin-bottom: 0;
`;

const StyledBetweenDay = styled(DateFormat)`
  font-size: ${rem('13px')};
  line-height: ${rem('18px')};
  ${mediaqueries.greaterThan('desktop')`
    font-size: ${props => props.theme.fontSize.xsmall};
  `};
`;

const StyledDash = styled.span`
  font-size: ${props => props.theme.fontSize.xsmall};
  margin: 0 ${rem('6px')};
`;

const StyledText = styled.span`
  font-size: ${props => props.theme.fontSize.xsmall};
  margin: 0;
`;

const StyledParagraph = styled.p`
  font-size: ${props => props.theme.fontSize.small};
  line-height: ${rem('18px')};
  margin: ${rem('2px')} 0 0;

  ${mediaqueries.greaterThan('desktop')`
    font-size: ${rem('15px')};
    padding-right: ${rem('30px')};
  `};
`;

export {
  StyledTitle,
  StyledTitleEditable,
  StyledExperience,
  StyledElement,
  StyledBox,
  StyledBoxLine,
  StyledMonth,
  StyledActuallity,
  StyledYear,
  StyledCurrentJobWrapper,
  StyledCompany,
  StyledButtonPlus,
  StyledPen,
  StyledEditable,
  StyledTrash,
  StyledCrate,
  StyledJob,
  StyledBetweenDay,
  StyledDash,
  StyledText,
  StyledParagraph
};
